/* eslint-disable no-undef */
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  getLocationPromise,
  showGeolocationPosition,
  handleGeolocationError,
} from '@utils/geolocationUtil'
import { GENERAL_STORE } from '../store'

export default {
  data: () => ({
    map: null,
    placemark: null,
    errorMessage: '',
    selectedAddress: '',
    miniAddress: '',
    isComplete: false,
    dotAddress: '',
    dotStreet: '',
    dotBuilding: '',
    dotLat: null,
    dotLng: null,
    mapCenterLat: 59.942568,
    mapCenterLng: 30.310828,
    mapZoom: 10,
    mapCity: null,
  }),

  computed: {
    ...mapState(GENERAL_STORE, ['selectedDot', 'form', 'base', 'order']),
    ...mapGetters(GENERAL_STORE, ['selectedCity', 'getDotIndex']),

    dotIsSetted() {
      return this.selectedDot.lat && this.selectedDot.building
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, ['toggleModals', 'updateDot', 'setIsSuggestionState']),
    ...mapActions(GENERAL_STORE, ['calculatePrice', 'changeCity', 'getClosestMetro']),
    closeModal() {
      this.toggleModals()
    },
    mapInit() {
      ymaps.ready(() => {
        const map = new ymaps.Map(
          'ymap_modal',
          {
            center: [this.mapCenterLat, this.mapCenterLng],
            zoom: this.mapZoom,
            controls: ['fullscreenControl', 'geolocationControl', 'zoomControl'],
          },
          {
            yandexMapDisablePoiInteractivity: true,
            suppressMapOpenBlock: true,
          }
        )

        const searchControl = new ymaps.control.SearchControl({
          options: {
            noPlacemark: true,
          },
        })

        map.controls.add(searchControl)
        map.behaviors.disable([
          'dblClickZoom',
          'rightMouseButtonMagnifier',
          'leftMouseButtonMagnifier',
          'ruler',
          'routeEditor',
        ])

        this.map = map

        const placemark = new ymaps.Placemark()

        this.placemark = placemark
        this.placemark.options.set('draggable', true)

        if (+this.mapZoom !== 10) {
          this.placemark.geometry.setCoordinates([this.mapCenterLat, this.mapCenterLng])
          this.placemark.properties.set('iconCaption', this.miniAddress)
        }

        this.map.geoObjects.add(this.placemark)

        this.map.events.add('click', e => {
          const coords = e.get('coords')

          this.setPlacemarkWithCoords(coords)
        })

        this.placemark.events.add('dragstart', () => {
          this.placemark.properties.set('iconCaption', 'Получаем информацию..')
        })
        this.placemark.events.add('dragend', () => {
          const coords = this.placemark.geometry.getCoordinates()

          this.setGeo(coords)
        })
      })
    },
    getAddress(result) {
      const data = result.geoObjects.get(0).properties.get('metaDataProperty.GeocoderMetaData')
      const isExact = data.precision === 'exact'
      const areaNames = ['house', 'street', 'locality', 'province', 'district']
      const components = data.Address.Components
      const address = {}

      components.forEach(element => {
        if (areaNames.includes(element.kind)) {
          address[element.kind] = element.name
        }
      })
      // eslint-disable-next-line prefer-destructuring
      address.splittedRegion = address.province.split(' ')[0]

      const isPickupDot = this.getDotIndex(this.selectedDot) === 0

      if (isPickupDot) {
        this.mapCity = this.form.allCities.find(city => this.checkCity(address, city))
      } else {
        this.mapCity = this.checkCity(address, this.selectedCity) ? this.selectedCity : false
      }

      if (!this.mapCity) {
        return {
          isComplete: false,
          errorMessage: 'Адрес за пределами зоны доставки.',
        }
      }

      return {
        isComplete: isExact,
        dotStreet: address.street,
        dotAddress: [address.locality, address.street].filter(s => !!s).join(', '),
        dotBuilding: address.house,
        dotSuburb: address.locality !== address.province ? address.locality : '',
        miniAddress: [address.street, address.house].filter(s => !!s).join(', '),
        fullAddress: [address.locality, address.street, address.house].filter(s => !!s).join(', '),
      }
    },
    confirmAddress() {
      if (+this.selectedCity.id !== +this.mapCity.id) {
        this.changeCity(this.mapCity.id)
      }

      this.updateDot({
        dot: this.selectedDot,
        data: [
          {
            key: 'address',
            value: this.dotAddress,
          },
          {
            key: 'street',
            value: this.dotStreet,
          },
          {
            key: 'building',
            value: this.dotBuilding,
          },
          {
            key: 'suburb',
            value: this.dotSuburb,
          },
          {
            key: 'lat',
            value: this.dotLat,
          },
          {
            key: 'lng',
            value: this.dotLng,
          },
          {
            key: 'isSetAuto',
            value: true,
          },
          {
            key: 'isSuggestionSet',
            value: true,
          },
        ],
      })
      this.calculatePrice()

      this.closeModal()
    },
    setGeo(coords) {
      const geocoder = ymaps.geocode(coords)

      geocoder.then(
        res => {
          const formattedAddress = this.getAddress(res)

          this.placemark.properties.set('iconCaption', formattedAddress.miniAddress)
          this.miniAddress = formattedAddress.miniAddress
          this.selectedAddress = formattedAddress.fullAddress
          this.errorMessage = formattedAddress.errorMessage
          this.isComplete = formattedAddress.isComplete
          this.dotAddress = formattedAddress.dotAddress
          this.dotStreet = formattedAddress.dotStreet
          this.dotBuilding = formattedAddress.dotBuilding
          this.dotSuburb = formattedAddress.dotSuburb
          // eslint-disable-next-line prefer-destructuring
          this.dotLat = coords[0]
          // eslint-disable-next-line prefer-destructuring
          this.dotLng = coords[1]
        },
        () => {
          console.log('ошибка установки метки')
        }
      )
    },
    checkCity(selectedCity, checkedCity = this.selectedCity) {
      return (
        checkedCity.name === selectedCity.province ||
        checkedCity.region === selectedCity.splittedRegion ||
        checkedCity.regions.find(
          region => region === selectedCity.province || region === selectedCity.splittedRegion
        )
      )
    },
    setPlacemarkWithCoords(coords) {
      this.placemark.properties.set('iconCaption', 'Получаем информацию..')
      this.placemark.geometry.setCoordinates(coords)
      this.setGeo(coords)
    },
    async setLocation() {
      let position

      try {
        position = await getLocationPromise()
      } catch (e) {
        console.log(handleGeolocationError(e))
      }

      if (position) {
        const coords = showGeolocationPosition(position)

        this.setPlacemarkWithCoords(coords)
        this.map.setCenter(coords)
      }
    },
  },
  created() {
    if (this.dotIsSetted) {
      const dot = this.selectedDot

      this.mapCenterLat = dot.lat
      this.mapCenterLng = dot.lng
      this.mapZoom = 13

      const splittedAddress = dot.address.split(', ')
      const street = dot.street || splittedAddress[0]
      const city = dot.suburb || this.selectedCity.name

      this.selectedAddress = [city, street, dot.building].join(', ')
      this.miniAddress = [street, dot.building].join(', ')
      this.isComplete = true
      this.dotAddress = dot.address
      this.dotBuilding = dot.building
      this.dotLat = dot.lat
      this.dotLng = dot.lng
    } else {
      this.mapCenterLat = this.selectedCity.lat
      this.mapCenterLng = this.selectedCity.lng
    }
  },
  mounted() {
    const interval = setInterval(() => {
      if (window.ymaps) {
        this.mapInit()

        if (!this.base.isAdmin && !this.dotIsSetted) {
          this.setLocation()
        }

        clearInterval(interval)
      }
    }, 300)
  },
}
